<template>
  <div class="component-wrapper">
    <h3>Manage District Users</h3>
    <button type="button" @click.prevent="cancelCreate">Return to District Overview</button>
    <div class="users-wrapper">
      <div class="users-table">
        <table>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Active</th>
            <th></th>
          </tr>
          <tr v-for="user in users" :key="user.userId">
            <td><span v-if="user.hasNotes">*</span>{{ user.userFirstName }} {{ user.userLastName }}</td>
            <td>{{ user.userEmail }}</td>
            <td><span v-if="user.userRole == 'admin'">CCS Admin</span><span v-if="user.userRole == 'teacher'">Teacher/Trainer</span></td>
            <td><i class="fa fa-check-circle" aria-hidden="true" v-if="user.active"></i></td>
            <td><a @click.prevent="editUser(user.userId)">Edit</a></td>
          </tr>
        </table>
      </div>
    </div>
    <!-- <button type="button" @click.prevent="createUser">Add a New User</button> -->
    <button type="button" @click.prevent="cancelCreate">Return to District Overview</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      users: []
    }
  },
  computed: {
    ...mapState([ 'districtId' ])
  },
  methods: {
    cancelCreate() {
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageDistrict')
    },
    createUser() {
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'createUser')
    },
    fetchUsers() {
      fb.usersCollection.where('districtId', '==', this.districtId).orderBy('userRole').orderBy('userLastName', 'asc').get().then((snap) => {
        snap.forEach((doc) => {
          this.users.push({
            userId: doc.id,
            userFirstName: doc.data().userFirstName,
            userLastName: doc.data().userLastName,
            userRole: doc.data().userRole,
            userEmail: doc.data().userEmail,
            active: doc.data().active,
            hasNotes: doc.data().notes
          })
        })
      })
    },
    editUser(userId) {
      // console.log('Editing user: ', userId)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUser')
      this.$store.commit('SET_USER_TO_MANAGE', userId)
    }
  },
  mounted() {
    this.fetchUsers()
  }
}
</script>

<style lang="css" scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  margin: 20px 0;
}
th, td {
  padding: 15px;
  border-bottom: 1px solid #cecece;
}
th {
  background: #0e314d;
  color: white;
  font-weight: 600;
  font-size: 1.2em
}
tr:nth-child(even) {
  background: #f7f7f7;
}
a {
  color: #7b8a1d;
}
a:hover {
  color: #c1d82f;
}
.warn {
  color: darkRed;
}
.warn:hover {
  color: red;
}
</style>
